import { React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { Collapse, ListItem, ListItemText } from '@material-ui/core'
import { ExpandLess, ExpandMore } from '@material-ui/icons'
import * as css from './Collapsible.css'

const styles = (theme: CentricTheme) => ({
  root: {},
  list:         {
    padding: `${theme.spacing() * 2}px ${theme.spacing() * 3}px`,
    height:  56
  },
  primary:      {
    color:    'rgba(27, 27, 27, 0.54)',
    fontSize: 12
  },
  icon:         {
    color:  'var(--icon-grey-2)',
    width:  20,
    height: 20,
    cursor: 'pointer'
  },
  wrapperInner: {
    padding: `0 ${theme.spacing() * 3}px`
  }
})

interface MyProps extends StyledProps {
  title?: string | React.ReactNode,
  open?: boolean,
  handleClick?: (e: React.MouseEvent<HTMLElement>) => void
}

@(withStyles as any)(styles)
export class Collapsible extends React.Component<MyProps> {
  static defaultProps = {
    title: '',
    open:  true
  }

  render() {
    const {handleClick, classes, title, open, className, children} = this.props
    return (<div className={classNames(css.root, classes.root, className)} data-open={open}>
        <ListItem className={classes.list} disableGutters onClick={handleClick}>
          <ListItemText primaryTypographyProps={{classes: {subheading: classes.primary}}} primary={title}/>
          {open ? <ExpandLess classes={{root: classes.icon}}/> : <ExpandMore classes={{root: classes.icon}}/>}
        </ListItem>
        <Collapse in={open} unmountOnExit classes={{wrapperInner: classes.wrapperInner}} >
          {children}
        </Collapse>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/Collapsible.tsx